const STORAGE_KEY = 'auth.postLoginRedirect'

export const setPostLoginRedirect = (path: string): void => {
  sessionStorage.setItem(STORAGE_KEY, path)
}

export const consumePostLoginRedirect = (): string | undefined => {
  const value = sessionStorage.getItem(STORAGE_KEY)
  if (!value) return undefined
  sessionStorage.removeItem(STORAGE_KEY)
  return value
}
